import React from "react";
import { useTranslation } from "react-i18next";
import { SFAreaChart } from "@sf-core";

const findYAxisTicks = (data) => {
  // Get the maximum 'hours' value from the data
  let maxVal = Math.max(...data.map((item) => item.hours));

  // Establish threshold - we want the smallest increment that produces at most 5 ticks exceeding the max value
  let threshold = maxVal + maxVal / 50;

  // Track increment and base
  let increment = 0;
  let base = increment * 4;

  // While base is less than threshold, increase increment by 10, and re-calculate base
  while (base <= threshold) {
    increment += 1;
    base = increment * 4;
  }

  // Generate yAxisTicks from 0 to base with step size of increment
  let yAxisTicks = [0, increment, 2 * increment, 3 * increment, base];

  return yAxisTicks;
};

const lines = [
  {
    type: "monotoneX",
    dataKey: "hours",
    //stroke: "#ffffff",
    //dotStroke: "#8884d8",
    strokeWidth: 2,
  },
];

const ProgressChart = ({ data }) => {
  const { t } = useTranslation();
  let yAxisTicks = findYAxisTicks(data);

  return (
    <>
      {data.length > 0 && (
        <SFAreaChart
          height={200}
          data={data}
          legend={t("homeScreen.heroes.chartLegend")}
          yAxis={{
            ticks: yAxisTicks,
          }}
          tooltipBody={(month, data) => {
            //pass hours to tooltip
            const { hours } = data[0].payload;
            return <div>{hours}</div>;
          }}
          xAxisKeyName="month"
          lines={lines}
          dataKey="month"
        />
      )}
    </>
  );
};

export default ProgressChart;
